import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash'

@Pipe({
	name: 'sortArrayByKey'
})
export class SortArrayByKeyPipe implements PipeTransform {

	transform(inputArray: any, keys: Array<string>): Array<any> {
		if (_.isNil(inputArray) || !_.isArray(inputArray)) {
			return [];
		}
		if (!_.isArray(keys) || keys.length === 0) {
			return inputArray;
		}
		const outputArray: Array<any> = _.sortBy(inputArray, keys)
		return outputArray;
	}

}

